import { PackageCheck } from "lucide-react";
import {
  STOCK_ALREADY_RETURNED_NOTICE,
  type ReturnReceipt,
} from "@estelle/domain";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ReceiptView } from "@/modules/orders/returns/ReceiptView";

/**
 * What the team did when this order's parcel came back (#529): one receipt per
 * shipment received, each as the receiving screen shows it, under the notice a
 * received order carries.
 *
 * The notice is there because the order stays open in Shopify after a receipt,
 * and someone cancelling it there with *Restock inventory* ticked would put the
 * stock in a second time. Shopify has no setting to prevent that, so this says
 * it where the person looking at the order will see it. The ERP's own Cancel
 * order action sends restock off for a received order, and says so.
 */
export function OrderReturns({ receipts }: { receipts: ReturnReceipt[] }) {
  if (receipts.length === 0) return null;
  return (
    <Card className="gap-3">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-sm">
          <PackageCheck className="size-4" aria-hidden />
          Return received
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p
          role="note"
          className="rounded-md border border-transparent bg-tint-yellow p-3 text-sm text-tint-yellow-foreground"
        >
          {STOCK_ALREADY_RETURNED_NOTICE}
        </p>
        {receipts.map((receipt) => (
          <ReceiptView key={receipt.id} receipt={receipt} />
        ))}
      </CardContent>
    </Card>
  );
}
